var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#102262",
    d: "M16.75 7a.75.75 0 0 0-1.5 0h1.5ZM12 3.75a.75.75 0 0 0 0-1.5v1.5ZM15.25 7A3.25 3.25 0 0 1 12 10.25v1.5A4.75 4.75 0 0 0 16.75 7h-1.5ZM12 10.25A3.25 3.25 0 0 1 8.75 7h-1.5A4.75 4.75 0 0 0 12 11.75v-1.5ZM8.75 7A3.25 3.25 0 0 1 12 3.75v-1.5A4.75 4.75 0 0 0 7.25 7h1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeWidth: 1.5,
    d: "M5 16.935c0-.86.54-1.628 1.351-1.917a16.794 16.794 0 0 1 11.298 0A2.036 2.036 0 0 1 19 16.934v1.315c0 1.188-1.052 2.1-2.227 1.932l-.955-.136a27.002 27.002 0 0 0-7.636 0l-.955.136A1.951 1.951 0 0 1 5 18.25v-1.315Z"
  })));
};
export default SvgUser;